import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import AdminLayout from "@/components/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import EmployeesPage from "@/pages/admin/EmployeesPage";
import ObrasPage from "@/pages/admin/ObrasPage";
import ClientesPage from "@/pages/admin/ClientesPage";
import FaltasPage from "@/pages/admin/FaltasPage";
import ReportsPage from "@/pages/admin/ReportsPage";
import EmployeePage from "@/pages/EmployeePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/ponto"
              element={
                <ProtectedRoute>
                  <EmployeePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute role="admin">
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="funcionarios" element={<EmployeesPage />} />
              <Route path="obras" element={<ObrasPage />} />
              <Route path="clientes" element={<ClientesPage />} />
              <Route path="faltas" element={<FaltasPage />} />
              <Route path="relatorios" element={<ReportsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
